import * as React from "react";
import { Language, FieldValueLocalTextList } from "typings/index";
import { BaseFieldEditor } from "../helper";
import TextListEditor from "./TextListEditor";
import { 
    CommandBar, 
    ICommandBarItemProps, 
    Dialog, 
    DialogFooter,
    PrimaryButton,
    DefaultButton,
    DialogType
} from "office-ui-fabric-react";
import styled from "styled-components";
import { Map } from "~/../typings";
import { GetLanguageMenu } from "./languageHelper";

export interface Props extends BaseFieldEditor
{
    value: FieldValueLocalTextList;
    placeholder?: string;
    languages: Language[];
}

const Editor = styled.div`
    span{
        cursor: pointer;
        width: 94%;
        height: 100%;
        display: block;
        background: white;
        padding: 3%;
        white-space: pre-wrap; 
   }
`;

const DialogContentStyle = styled.div`
    z-index: 100;
    position: relative;
    display: flex;
   .locale-textarea
   {

        float: left;
        width: 48%;
        &:first-child
        {
            padding: 0 4% 2% 0;
        }
        
       textarea
       {
            width: 98%;
            min-height: 150px;
            margin-bottom: 0 !important;
       }
   }

   .ms-TextField
   {
       margin:15px 0px 0px 0px;
       .ms-TextField-fieldGroup 
       {
            border: 0px;
            border-bottom: 1px solid rgb(194, 194, 194);
       }
      
   }
`;

function LocaleTextListEditor(props: Props)
{
    const [language, setLanguage] = React.useState<Language>(props.languages[0]);
    const [edit, setEdit] = React.useState<boolean>(false);

    const [value, setValue] = React.useState<Map<string[]> | undefined>(undefined);

    React.useEffect(() =>
    {
        if (props.value && props.value.value)
        {
            setValue(props.value.value);
        }
    }, [props.value]);
    const toggleEditMode = () => setEdit(!edit);

    const onSave = () =>
    {
        const fieldValue: FieldValueLocalTextList = {...props.value, value };
        props.onValueChange(fieldValue);
        toggleEditMode();
    };

    const onCancel =  () =>
    {
        setValue(props.value ? props.value.value : undefined);
        toggleEditMode();
    };

    
    const onValueChange = React.useCallback((language: string, newValue: string[]) =>
    {
        const temp = {...value,
            [language]: newValue
         };
        setValue(temp);
     
    }, [value, props.value]);

    const commandBarOptions: ICommandBarItemProps[] = GetLanguageMenu(props.languages, setLanguage, language);
    return (
        <Editor>
            <CommandBar
                style={{background: "transparent"}}
                items={commandBarOptions}
                farItems={[{name:"Edit", key:"edit", onClick: toggleEditMode}]}
            />
            <span onClick={toggleEditMode}>
                {value && value[language.name] ? value[language.name].map(val => <p>{val}</p>) : undefined}
            </span>
            <Dialog hidden={!edit} onDismiss={toggleEditMode} minWidth={900} 
                dialogContentProps={{ type: DialogType.normal, title: props.field.label._DEFAULT }}
                
                >
                    <DialogContentStyle>
                        <TextListEditor
                            languageDefaultIndex={props.languages.findIndex(x => x.name === language.name)}
                            languages={props.languages}
                            values={value}
                            onValueChange= {onValueChange}
                            focus={true}
                            key="1"
                            propertyName={props.field.name}
                        />    
                        {props.languages.length > 1 ? <TextListEditor
                            languageDefaultIndex={1}
                            languages={props.languages}
                            values={value}
                            onValueChange= {onValueChange}
                            key="2"
                            propertyName={props.field.name}
                        /> : null}    
                    </DialogContentStyle>
                <DialogFooter>
                    <PrimaryButton onClick={onSave} text="Save" />
                    <DefaultButton onClick={onCancel} text="Cancel" />
                </DialogFooter>
            </Dialog>
        </Editor>
    );
}

export default LocaleTextListEditor;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/localeTextList/index.tsx